import { useContext } from "react";
import { DataContext } from "../../../store/data-context";
import styles from "./Section5.module.css";
import Testimonial from "./Testimonial";

const Section5 = () => {
  const { section5Data } =
    useContext(DataContext);

  return (
    <section
      className={styles["main-section__5"]}
    >
      <h2>Our Testimonials</h2>
      <section
        className={
          styles["main-section__5__testimonials"]
        }
      >
        {section5Data.map((data) => {
          return (
            <Testimonial
              data={data}
              key={data.id}
            />
          );
        })}
      </section>
    </section>
  );
};

export default Section5;
